import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Tutorial from './docs-main/blog-pages/Tutorial.vue';
import TutorialFolder from './docs-main/reference-pages/TutorialFolder.vue';
import SearchPage from '@/components/docs-main/search/SearchPage.vue';
import ReferencesPage from './docs-main/reference-pages/References.vue';
import HowtosPage from './docs-main/blog-pages/HowTos.vue';
import { currentInstance } from '@/heplers';
import { useRoute } from '@/heplers/useRoute';
import { useStore } from '@/heplers/useStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeLayoutComponent',
  setup(__props) {

const route = useRoute();
const store = useStore();

const content = computed(() => store.getters.getContent);

const isSearchPage = computed(() => {
  return route.value.name === 'Search';
});

const isReferencesPage = computed(() => {
  return currentInstance === 'vox'
    ? route.value.meta.fqdn === 'references'
    : route.value.meta.fqdn === 'references' || route.value.name === 'Voximplant Kit';
});

const isHowtosPage = computed(() => {
  return route.value.meta.fqdn === 'howtos';
});

const isTutorialPage = computed(() => {
  const tutorialKinds = ['tutorial', 'howto', 'changelog'];
  const tutorialsFolderFqdn = ['howtos', 'tutorials', 'changelog'];
  const metaSplit = route.value.meta.fqdn.split('.');

  if (content.value?.kind === 'folder') return false;

  // For tutorials Page inside References
  if (tutorialKinds.includes(content.value?.kind) && metaSplit.length > 1) return true;

  // For other
  return tutorialsFolderFqdn.includes(metaSplit[0]) && metaSplit.length > 1;
});

const computeNameComponent = computed(() => {
  if (isReferencesPage.value) return ReferencesPage;

  if (!content.value && !isSearchPage.value) return Tutorial;

  if (isSearchPage.value) return SearchPage;

  if (isTutorialPage.value) return Tutorial;

  if (isHowtosPage.value) return HowtosPage;

  return TutorialFolder;
});

return { __sfc: true,route, store, content, isSearchPage, isReferencesPage, isHowtosPage, isTutorialPage, computeNameComponent }
}

})